 /* global window:true */
/* global PDFDocument:true */

import React, { PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';
import _ from 'underscore';
import PDFObject from 'pdfobject';
import lockr from 'lockr';

const TITLE = 'Resources';
// const pdfOpenParams = { toolbar: '0', page: 2 };

const {
    API_URL,
    AUTH_KEY
} = require('../core/constants').default;

class ResourceViewPage extends React.Component {
    componentDidMount() {
        const { actions, resourceId } = this.props;
        // console.log('resource', resource);

        // if (!_.isUndefined(resource) && !PDFObject.supportsPDFs) {
        //     PDFObject.embed(resource.pdf, '#pdf-container', pdfOpenParams); // https://pdfobject.com/#api
        // }

        // load resources
        actions.resourcesRequest();

        // register view count
        actions.registerResourceViewRequest({ resource_id: resourceId });

        // log analytics
        ReactGA.pageview(window.location.pathname);
        ReactGA.event({
            category: 'Respource',
            action: 'Viewing an resource'
        });
    }

    // componentDidUpdate(prevProps) {
    //     if (_.isUndefined(prevProps.resource) && !_.isUndefined(this.props.resource) && !PDFObject.supportsPDFs) {
    //         PDFObject.embed(this.props.resource.pdf, '#pdf-container', pdfOpenParams);
    //     }
    // }

    render() {
        const { resource } = this.props;
        // console.log('resource', resource);

        if (_.isUndefined(resource)) {
            return <p>loading...</p>;
        }

        // hide toolbar for 'storybook' only
        const toolBarHidden = resource.category === 'storybook' ? 0 : 1;

        const authKey = lockr.get(AUTH_KEY);

        return (
            <div className="portfolio-wrapper index-1 resource-view">
                <Helmet title={TITLE} />
                {PDFObject.supportsPDFs ?
                    <object
                        data={`${resource.pdf}#toolbar=${toolBarHidden}`}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style={{ height: '85vh' }}>
                        <p>This browser does not support inline PDFs. Please update your browser to Google Chrome or Safari.</p>
                    </object>
                    :
                    <iframe
                        style={{ height: '85vh' }}
                        src={`/ViewerJS/#${resource.pdf}`}
                        width="100%"
                        height="100%"
                        allowFullScreen />
                }
                {resource.category === 'storybook' ?
                    <a
                        type="button"
                        className="btn btn-success btn-floating"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${API_URL}resource/generate-certificate/${resource.id}?access-token=${authKey}`}>
                        Download certificate
                    </a>
                : null}
            </div>
        );
    }
}

ResourceViewPage.propTypes = {
    actions: PropTypes.object,
    resource: PropTypes.object,
    resourceId: PropTypes.string
};

export default ResourceViewPage;



/** WEBPACK FOOTER **
 ** ./src/pages/ResourceViewPage.js
 **/